import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BenePignoratoImmobile } from '../../../models/immobili/bene-pignorato-immobile';

@Component({
    selector: '[add_doc_to_bene_immobile]',
  templateUrl: 'add-to-bene-immobile.component.html',
})

export class AddDocumentoToBeneImmobileComponent {
  @Input()
  bene: BenePignoratoImmobile;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(bene: BenePignoratoImmobile) {
    this.onClickAddToEntity.emit(bene);
  }
}
